
<div
  id="drawer-content"
  class="
    compare-grid-drawer--content
    hmf-position-relative
    hmf-pl-0"
  (scroll)="verticalScrolling()"
  >
	<div #hiddenIntersectionElement class="hidden-intersection-element" ></div>

	<div class="upper-grid-sticky-container hmf-position-sticky" >
      <plp-components-carousel-button
        class="hmf-position-absolute hmf-display-none hmf-ml-xs hmf-ml-md-s carousel-button prev"
        [class.hmf-display-block]="isScrollLeftAllowed()"
        [previous]="true"
        [showLeftArrow]="isScrollLeftAllowed()"
        (clickEvent)="scrollToSide('left')">
      </plp-components-carousel-button>

	  <div
          #upperGridSection
          class="product-card-scrollable-area hmf-display-flex hmf-align-items-flex-start hmf-px-s hmf-px-sm-m"
          (mouseenter)="updateCurrentElement('upperGridSection')"
          (touchmove)="updateCurrentElement('upperGridSection')"
          (scroll)="onHorizontalScroll($event)"
        >
          @for (compareProduct of compareBarList(); track trackByFn($index, compareProduct)) {
			<plp-components-compare-grid-product-card
				[isLoading]="isLoading()"
				[isCompact]="isSticky()">
			</plp-components-compare-grid-product-card>
          }
        </div>

        <plp-components-carousel-button
          class="hmf-position-absolute hmf-display-none hmf-mr-xs hmf-mr-md-s carousel-button next"
          [class.hmf-display-block]="isScrollRightAllowed()"
          [previous]="false"
          [showRightArrow]="isScrollRightAllowed()"
          (clickEvent)="scrollToSide('right')">
        </plp-components-carousel-button>

        @if (isDrawerScrollable()) {
          <div class="custom-scrollbar hmf-mb-s hmf-mx-s hmf-mx-sm-m">
            <div class="scroll-indicator hmf-position-absolute hmf-px-sm-m" #scrollIndicator></div>
          </div>
        }
    </div>

    <div
      #lowerGridSection
		  class="product-details-section hmf-position-relative"
      (mouseenter)="updateCurrentElement('lowerGridSection')"
      (touchmove)="updateCurrentElement('lowerGridSection')"
      (scroll)="onHorizontalScroll($event)"
		>
      <div class="scrollable-area hmf-display-flex hmf-flex-column hmf-px-s hmf-px-sm-m">
        <div class="fulfillment-and-attributes-section hmf-display-flex hmf-mb-l">
          @for (compareProduct of compareBarList(); track trackByFn($index, compareProduct)) {
            <plp-components-fulfillment-attribute-section
              [isLoading]="isLoading()"
              [isLoadingFulfillment]="isLoadingFulfillmentData()"
            >
            </plp-components-fulfillment-attribute-section>
          }
        </div>

        <h3 class="hmf-header-bold-m hmf-pt-xxs hmf-mb-s">Specs</h3>
        <div class="specs-section hmf-display-flex hmf-mb-l">
          @for (compareProduct of compareBarList(); track trackByFn($index, compareProduct)) {
            <plp-components-specs-section
              [isLoading]="isLoading()"
            ></plp-components-specs-section>
          }
        </div>
      </div>
    </div>
</div>
